import React from 'react';


interface AiChakiProps {
    promoEvent?: {
        title: string;
        logoUrl: string;
        description: string;
        action: string;
    };
}


const AiChaki: React.FC<AiChakiProps> = ({ promoEvent }) => {
    if (!promoEvent) return null;
    return (
        <div className='promo-event-card '>
            {/* logo */}
            <div className='promo-logo '>
                <img
                    src={promoEvent.logoUrl}
                    alt={promoEvent.title}
                    className='promo-event-logo'
                />
            </div>
            {/* details */}
            <div className='promo-content'>
                <h2 className='promo-title title-wiggle'>{promoEvent.title}</h2>
                <p className='promo-description '>{promoEvent.description}</p>
                {promoEvent.action && (
                    <button className='promo-action-btn'>{promoEvent.action}</button>
                )}
            </div>
        </div>
    );
};

export default AiChaki;